<template>
  <div>
    <MainHeader :title="'Budget'">
      <template #right>
        <div
          class="help-beacon"
          @click="openBeacon"
          title="Get Help"
          role="button"
          aria-label="Get Help"
        >
          <font-awesome-icon
            :icon="['fas', 'question']"
            class="help-beacon-icon"
          />
        </div>
      </template>
    </MainHeader>

    <div>
      <div class="et-tabs">
        <button
          class="et-tab"
          :class="{ active: monthlyBudgetSliderSelected }"
          @click="monthlyBudgetSliderSelected = true"
        >
          Monthly
        </button>
        <button
          class="et-tab"
          :class="{ active: !monthlyBudgetSliderSelected }"
          @click="monthlyBudgetSliderSelected = false"
        >
          Annual
        </button>
      </div>

      <div v-if="monthlyBudgetSliderSelected">
        <MonthlyBudget />
      </div>
      <div v-else>
        <AnnualBudget />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';
import MonthlyBudget from '../components/MonthlyBudget.vue';
import AnnualBudget from '../components/AnnualBudget.vue';
import MainHeader from '../components/View-Header.vue';

export default {
  name: 'UserBudget',
  components: { MonthlyBudget, AnnualBudget, MainHeader },
  setup() {
    const store = useMyStore();
    const router = useRouter();
    let monthlyBudgetSliderSelected = ref(true);

    onMounted(() => {
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) mainElement.scrollTo(0, 0);
      }, 100);
      store.getAllCategories();
    });

    onBeforeUnmount(() => {
      window.Beacon('close');
    });

    const openBeacon = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('on', 'ready', () => {
          window.Beacon('open');
          window.Beacon('navigate', '/docs/search?query=budget');
        });
        window.Beacon('open');
        window.Beacon('navigate', '/docs/search?query=budget');
      } else {
        console.error('Beacon is not initialized');
      }
    };

    return {
      store,
      router,
      monthlyBudgetSliderSelected,
      openBeacon,
    };
  },
};
</script>

<style scoped>
.help-beacon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--gradient-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-purple);
  transition:
    transform var(--transition-fast),
    box-shadow var(--transition-fast);
}
.help-beacon:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-purple-lg);
}
.help-beacon-icon {
  color: white;
  font-size: 13px;
}

.et-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  background: #f0f0f4;
  border-radius: var(--radius-pill);
  padding: 4px;
  margin: 1em;
}
.dark-theme .et-tabs {
  background: #1a2535;
}

.et-tab {
  border: none;
  border-radius: var(--radius-pill);
  padding: 0.6rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: #888;
  transition: all 0.2s ease;
}
.et-tab.active {
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  color: white;
  box-shadow: 0 4px 12px rgba(127, 119, 221, 0.3);
}
</style>

<!-- <template>
  <div>
    <div>
      <MainHeader :title="'Budget'">
        <template #right>
          <div class="beacon-launcher" @click="openBeacon" title="Get Help">
            <font-awesome-icon
              :icon="['fas', 'question']"
              class="beacon-icon"
            />
          </div>
        </template>
      </MainHeader>
    </div>
    <div class="view">
      <div>
        <Slider
          :options="sliderOptions"
          @sliderSelection="sliderOptionUpdated($event)"
        ></Slider>
      </div>
      <div v-if="monthlyBudgetSliderSelected">
        <MonthlyBudget></MonthlyBudget>
      </div>
      <div v-else>
        <AnnualBudget></AnnualBudget>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';

import MonthlyBudget from '../components/MonthlyBudget.vue';
import AnnualBudget from '../components/AnnualBudget.vue';
import MainHeader from '../components/View-Header.vue';
import Slider from '../components/Slider.vue';
import { Budget_Types } from '../utils/constants.js';

export default {
  name: 'User-Budget',
  components: { MonthlyBudget, AnnualBudget, MainHeader, Slider },
  setup() {
    const store = useMyStore();
    const router = useRouter();
    const sliderOptions = [
      { label: 'Monthly', disabled: false },
      { label: 'Annual', disabled: true },
    ];
    let monthlyBudgetSliderSelected = ref(true);

    const sliderOptionUpdated = (selection) => {
      if (selection === Budget_Types.monthly) {
        monthlyBudgetSliderSelected.value = true;
      } else {
        monthlyBudgetSliderSelected.value = false;
      }
    };

    onMounted(() => {
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) {
          mainElement.scrollTo(0, 0);
        }
      }, 100);
      store.getAllCategories();
    });

    onBeforeUnmount(() => {
      window.Beacon('close');
    });

    const openBeacon = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('on', 'ready', () => {
          window.Beacon('open');
          window.Beacon('navigate', '/docs/search?query=budget');
        });
        window.Beacon('open');
        window.Beacon('navigate', '/docs/search?query=budget');
      } else {
        console.error('Beacon is not initialized');
      }
    };

    return {
      store,
      router,
      sliderOptions,
      sliderOptionUpdated,
      monthlyBudgetSliderSelected,
      openBeacon,
    };
  },
};
</script>
<style scoped></style> -->
